import React from 'react';
import { cn } from '@/lib/utils';

const MAP = {
  // Partner statuses
  pending: 'bg-amber-100 text-amber-800 border-amber-200',
  approved: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  rejected: 'bg-rose-100 text-rose-800 border-rose-200',
  suspended: 'bg-slate-200 text-slate-700 border-slate-300',
  // Booking statuses
  requested: 'bg-sky-100 text-sky-800 border-sky-200',
  accepted: 'bg-indigo-100 text-indigo-800 border-indigo-200',
  confirmed: 'bg-violet-100 text-violet-800 border-violet-200',
  in_progress: 'bg-blue-100 text-blue-800 border-blue-200',
  completed: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  cancelled: 'bg-rose-100 text-rose-800 border-rose-200',
  refunded: 'bg-fuchsia-100 text-fuchsia-800 border-fuchsia-200',
  // Payment statuses
  unpaid: 'bg-slate-100 text-slate-700 border-slate-200',
  paid: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  failed: 'bg-rose-100 text-rose-800 border-rose-200',
};

export default function StatusBadge({ value, className }) {
  const cls = MAP[value] || 'bg-slate-100 text-slate-700 border-slate-200';
  const label = String(value || '').replace(/_/g, ' ');
  return (
    <span
      data-testid={`status-badge-${value}`}
      className={cn(
        'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium capitalize',
        cls,
        className,
      )}
    >
      {label || '-'}
    </span>
  );
}
